import { Injectable } from '@angular/core';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { Regional } from './regional.model';

@Injectable({
  providedIn: 'root'
})
export class RegionalService {
  listRegional:Regional[];
  constructor(private generalHttp:GeneralHttpService) { }

  getRegional(){
    return this.generalHttp.getHttp('AdmRegional').then(r =>this.listRegional = r as Regional[]);
  }

  updateRegional(){
    return this.generalHttp.putHttpNotValue('AdmRegional')
  }

}
